<template>
    <headerLayout></headerLayout>
    <div class="page-padding" style="position: relative">
        <div class="price-bg"></div>
        <div class="slogen-box">
            <div class="title">借助强大的 MasterGo<br />提升设计效率
            </div>
            <p class="description">根据需要选择属于个人或团队的解决方案</p>
        </div>
        <div class="pricing-box">
            <div class="content">
                <div class="item">
                    <div class="title">免费版</div>
                    <div class="description">适合个人和小型团队使用，100 人以下团队和教育行业免费</div>
                    <div class="detail" v-for="item in free" :key="'free' + item.label">
                        <img class="icon" src="@/assets/icon/check_blue.svg" />
                        <div class="text">{{ item.label }}</div>
                        <div class="supplement">{{ item.value }}</div>
                    </div>
                    <button class="btn btn-primary pointer">免费使用</button>
                </div>
                <div class="item ep">
                    <div class="title">企业版</div>
                    <div class="description">适合对权限管理、数据安全有更高要求的团队或企业</div>
                    <div class="detail" v-for="item in ep" :key="'free' + item.label">
                        <img class="icon" src="@/assets/icon/check_gray.svg" />
                        <div class="text">{{ item.label }}</div>
                        <div class="supplement">{{ item.value }}</div>
                    </div>
                    <button class="btn btn-info pointer">敬请期待</button>
                </div>
                <div class="item">
                    <div class="title">企业内网部署版</div>
                    <div class="description">适合对数据私密性和企业自有系统集成有更高要求的企业</div>
                    <div class="detail" v-for="item in ep_in" :key="'free' + item.label">
                        <img class="icon" src="@/assets/icon/check_green.svg" />
                        <div class="text">{{ item.label }}</div>
                        <div class="supplement">{{ item.value }}</div>
                    </div>
                    <button class="btn btn-success pointer">联系我们</button>
                </div>
            </div>
        </div>
    </div>
    <footer-layout></footer-layout>
</template>

<script>
import FooterLayout from './layout/footerLayout.vue';
import headerLayout from "./layout/headerLayout.vue";
export default {
    components: { headerLayout, FooterLayout },
    data() {
        return {
            free: [
                { label: "文件数量", value: "不限" },
                { label: "文件协作人数", value: "不限" },
                { label: "团队数量", value: "不限" },
                { label: "历史版本保存", value: "永久" },
                { label: "客户端", value: "macOS, Win" },
                { label: "镜像预览APP", value: "iOS, Android" },
                { label: "服务支持", value: "7 × 12 小时" },
            ],
            ep: [
                { label: "所有免费版功能", value: "" },
                { label: "单点登录（SSO）", value: "" },
                { label: "管理员权限控制", value: "" },
                { label: "数据安全备份", value: "" },
                { label: "服务支持", value: "7 ×24 小时" },
            ],
            ep_in: [
                { label: "所有免费版功能", value: "" },
                { label: "企业自有服务器部署", value: "" },
                { label: "完备的开放接口", value: "" },
                { label: "企业内部系统深度集成", value: "" },
                { label: "专属培训和技术支持", value: "" },
                { label: "一对一服务支持", value: "7 ×24 小时" },
            ],
        }
    },
}
</script>

<style scoped>
.price-bg {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    width: 100%;
    height: 100vh;
    background-image: url('@/assets/image/price-bg.png');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    z-index: -1;
}

.slogen-box {
    max-width: 1200px;
    margin: 0px auto;
    padding: 68px 0px 80px;
}

.slogen-box>.title {
    font-size: 50px;
    font-weight: 800;
    line-height: 60px;
    text-align: center;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.85);
    margin: 0px 0px 32px;
}

.slogen-box>.description {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.5);
}

.pricing-box {
    max-width: 1200px;
    margin: 0px auto;
}

.pricing-box>.content {
    display: grid;
    justify-content: center;
    grid-template-columns: 1fr 1fr 1fr;
    -webkit-box-align: center;
    gap: 24px;
    margin: 0 1rem;
}

.pricing-box>.content>.item {
    max-width: 760px;
    position: relative;
    /* height: 660px; */
    box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    padding: 40px;
    padding-bottom: 100px;
    border-radius: 8px;
    background: rgb(255, 255, 255);
}

.pricing-box>.content>.item>.title {
    text-align: center;
    font-size: 32px;
    font-weight: 800;
    line-height: 36px;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.85);
}

.pricing-box>.content>.item>.description {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.85);
    margin: 32px 0px 0px;
    padding: 16px 24px;
    background: rgba(253, 201, 0, 0.2);
    border-radius: 8px;
}

.pricing-box>.content>.item.ep>.description {
    background: rgb(242, 243, 245);
}


.pricing-box .detail {
    height: 24px;
    line-height: 24px;
    position: relative;
    margin: 24px 0px 0px;
}

.pricing-box .detail>.icon {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20p
}

.pricing-box .detail>.text {
    position: absolute;
    top: 0px;
    left: 32px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.85);
}

.pricing-box .detail>.supplement {
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    color: rgba(0, 0, 0, 0.5);
}

.pricing-box>.content>.item>button {
    position: absolute;
    left: 1.5rem;
    right: 1.5rem;
    bottom: 0;
    margin: 1.25rem 0;
}

@media (max-width: 900px) {

    .pricing-box>.content {
        grid-template-columns: 1fr 1fr;
        gap: 32px;
    }
    .slogen-box>.title {
        font-size: 40px;
    }
}

@media (max-width: 765px) {
    .slogen-box {
        padding: 80px 0px 80px;
    }

    .slogen-box>.title {
        font-size: 26px;
        margin-bottom: 20px;
        line-height: unset;
    }

    .slogen-box>.description {
        font-size: 1rem;
    }

    .pricing-box>.content {
        grid-template-columns: 1fr;
        gap: 32px;
    }
    .pricing-box>.content>.item>.title {
        font-size: 26px;
    }
}
</style>